"use strict";

// Class definition
var KTAjax = function() {
    return {
        // returns the cookie with the given name,
        // or undefined if not found
        get: async function(token, data, formtype, url) {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer " + token);
            myHeaders.append("X-CSRF-TOKEN", token);

            var requestOptions = {
                method: formtype,
                headers: myHeaders,
                body: data,
                redirect: 'follow'
            };

            try {
                let request = await fetch(url, requestOptions);
                let response = [];
                if (request.ok) {
                    response = await request.json();
                } else {
                    toastr.error("HTTP-Error: Problem with connection/network!, (" + request.status + ")", "Error")
                }

                return response;
            } catch (error) {
                toastr.error(error, "Error")
            }
        },
    }
}();

// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTAjax;
}